<template>
  <div>
    <v-card flat class="rounded-lg pa-6">
      <div>
        <title-page
          back="true"
          :align="'center'"
          colorIconBack="#006341"
          title="Monitoring Internship"
        />
        <h3 v-if="dataSet && !loading" style="font-weight: normal">
          {{ dataSet.title }}
        </h3>
      </div>
      <div class="mt-2">
        <h4>Description</h4>
        <v-textarea
          v-if="dataSet && !loading"
          class="my-4 rounded-lg"
          auto-grow
          outlined
          rows="4"
          placeholder="Put the description here"
          v-model="dataSet.description"
          hide-details
          dense
        ></v-textarea>
        <v-skeleton-loader
          class="mt-2"
          height="90px"
          v-if="loading"
          type="image"
        ></v-skeleton-loader>
      </div>
    </v-card>
    <v-card flat class="rounded-lg pa-6 mt-6">
      <div>
        <h4>Internship Place</h4>
        <v-text-field
          v-if="dataSet && !loading"
          class="d-flex align-center mt-2 rounded-lg"
          dense
          outlined
          filled
          readonly
          v-model="dataSet.destination"
          placeholder="Put the title here"
          hide-details
          color="green"
          style="width: 30%"
        ></v-text-field>
        <v-skeleton-loader
          class="mt-2"
          width="150px"
          v-if="loading"
          height="30px"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-6">
        <h4>Status Internship</h4>
        <v-select
          v-if="!loading && dataSet"
          class="my-2 rounded-lg"
          dense
          outlined
          :items="optStatusInternship"
          item-text="name"
          item-value="val"
          v-model="dataSet.status"
          placeholder="Choose Status Internship"
          flat
          hide-details
          style="width: 50%"
          solo
        ></v-select>
        <v-skeleton-loader
          class="mt-2"
          width="150px"
          v-if="loading"
          height="30px"
          type="image"
        ></v-skeleton-loader>
      </div>
      <div class="mt-2">
        <h4 class="my-4">Duration</h4>
        <div class="d-flex">
          <div>
            <h6>Start</h6>
            <v-menu
              v-if="!loading && dataSet"
              v-model="showPickerStart"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataSet.durasi_start"
                  prepend-inner-icon="mdi-calendar-range"
                  readonly
                  dense
                  v-on="on"
                  placeholder="Start Internship Date"
                  outlined
                  class="rounded-lg"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataSet.durasi_start"
                @input="closeDateMenu('start')"
              ></v-date-picker>
            </v-menu>
            <v-skeleton-loader
              class="mt-2"
              width="150px"
              height="30px"
              v-if="loading"
              type="image"
            ></v-skeleton-loader>
          </div>
          <div class="ml-10">
            <h6>End</h6>
            <v-menu
              v-if="!loading && dataSet"
              v-model="showPickerEnd"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="dataSet.durasi_end"
                  prepend-inner-icon="mdi-calendar-range"
                  dense
                  readonly
                  placeholder="End Internship Date"
                  v-on="on"
                  outlined
                  class="rounded-lg"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dataSet.durasi_end"
                :allowed-dates="allowedDates"
                @input="closeDateMenu('end')"
              ></v-date-picker>
            </v-menu>
            <v-skeleton-loader
              class="mt-2"
              width="150px"
              v-if="loading"
              type="image"
              height="30px"
            ></v-skeleton-loader>
          </div>
        </div>
      </div>
      <div v-if="!loading" class="d-flex my-2">
        <v-btn
          class="bg_default text-capitalize rounded-lg"
          depressed
          dark
          @click="saveData"
          >SAVE</v-btn
        >
      </div>
    </v-card>
  </div>
</template>

<script>
import titlePage from "../../../../../components/atom/titlePage.vue";
export default {
  components: { titlePage },
  name: "monitoringInternship",
  data() {
    return {
      showPickerStart: false,
      showPickerEnd: false,
      optStatusInternship: [
        {
          name: "Active",
          val: "aktif",
        },
        {
          name: "Done",
          val: "selesai",
        },
      ],
      loading: true,
      dataSet: null,
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    closeDateMenu(type) {
      if (type == "start") {
        this.showPickerStart = false;
        this.dataSet.durasi_start == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      } else {
        this.showPickerEnd = false;
        this.dataSet.durasi_end == ""
          ? this.date.format("dddd, MMMM Do YYYY")
          : "";
      }
    },
    saveData() {
      this.loading = true;
      let body = {
        id: this.$route.params.idProposal,
        status: this.dataSet.status,
        durasi_start: this.dataSet.durasi_start,
        durasi_end: this.dataSet.durasi_start,
        description: this.dataSet.description,
      };
      let data = {
        path: `scholar/proposal/internships/monitor`,
        body: body,
      };
      this.$store
        .dispatch("user/postApi", data)
        .then((data) => {
          this.loading = false;
          this.$store.dispatch("notify", {
            msg: data.message,
            type: "success",
          });
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    fetchData() {
      this.loading = true;
      let data = {
        path: `scholar/proposal/internships?sort=-created_at&filter[id]=${this.$route.params.idProposal}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data.length ? data.data[0] : null;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    allowedDates(val) {
      let date = "";
      if (this.dataSet.durasi_start) {
        return val >= this.dataSet.durasi_start.substr(0, 10);
      } else {
        return val >= date.substr(0, 10);
      }
    },
  },
};
</script>

<style></style>
